export default __webpack_public_path__ + "static/media/54.75714434.jpg";